import { ChronoCodeWrapper, ChronocodeCriteria, ChronoCodeScenario } from '@wizeoo/akm-message-lib';
import { WizCommand } from '@wizeoo/akm-component-lib';
import { WIZ_COMMAND_METHOD} from '@wizeoo/akm-core-lib';
import { Model } from '../../../model/model';
import { ExternalAPI } from '../../../model/external-api';

/**
 * Commande REST de recherche des chronocodes
 */
export class ChronocodeCmd extends WizCommand<ChronoCodeWrapper> {

    protected model: Model = null;

    constructor(model: Model) {
      super();
      this.model = model;
    }

    /** retourne un wrapper pre-alimenté */
    public chronocodeWrapper(): ChronoCodeWrapper {
        const wrapper: ChronoCodeWrapper = new ChronoCodeWrapper();
        wrapper.criteria = new ChronocodeCriteria();
        wrapper.criteria.manageDeprecated = true;
        wrapper.criteria.manageDeleted = true;
        wrapper.criteria.domain = this.model.domainCode;
        wrapper.criteria.businessUnitCode = this.model.businessUnitCode;
        wrapper.scenario = new ChronoCodeScenario();
        wrapper.scenario.languageCode = this.model.currentLocaleCode;
        wrapper.scenario.manageChronoCodeLevels = true;
        return wrapper;
    }

    /** configuration du chargement */
    public find(viewCallback?: Function): ChronocodeCmd {
        const wrapper: ChronoCodeWrapper = this.chronocodeWrapper();
        wrapper.method = WIZ_COMMAND_METHOD.FIND;
        this.configureRemote(ExternalAPI.CHRONOCODE_API, wrapper, viewCallback);
        return this;
    }

    /** sur retour de find, construction */
    public wizResult() {
        super.wizResult();

        if (this.result?.entities) {
            this.model.chronocodeEngine.feedChronocodesMap(this.result.entities);
        }
    }

}
